module.exports = __webpack_public_path__ + "img/hopways.0100759e.png";